<div class="convenience-fee-box">
    <p class="convenience-fee-text"><span> Convenience fee of <strong class="text-style-1"> {{ getpayUConvenienceFee()
                | currency:'INR':'symbol':'2.2'}}
            </strong> (Incl of {{payUConvenienceFeeGSTPercentage}}% GST) </span>
        <span> <strong class="text-style-1"> waived off by Finzy </strong> </span>
        <app-tooltip placement="bottom">
            <i class="fa fa-info-circle text-style-1 info-icon" trigger></i>
            <div content style="width: 35vw; max-width: 250px">
                <div class="row p-0 m-0">
                    <p class="col-xs-12">
                        The waiver of convenience fee is for a limited period and subject to change after <strong>March
                            31st 2022</strong>
                    </p>
                </div>
            </div>
        </app-tooltip>
    </p>
</div>

<div class="net-banking-container">
    <div class="select-the-bank">
        <p>Select the bank</p>
    </div>

    <form [formGroup]=netBankingForm>

        <div class="row box-wrapper">

            <div class="col-xs-4">
                <div class="bank-logo-box">
                    <input type="radio" title="AXIS Bank" value="AXIS_BANK" name="bankName" formControlName="bankName"
                        [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <label><img class="bank-logo1"
                            src="../../../assets/images/payment-collection/axis-bank-logo.png"></label>
                </div>
            </div>
            <div class="col-xs-4">
                <div class="bank-logo-box">
                    <input type="radio" title="HDFC Bank" value="HDFC_BANK" name="bankName" formControlName="bankName"
                        [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <label><img class="bank-logo2"
                            src="../../../assets/images/payment-collection/hdfc-bank-logo.png"></label>
                </div>
            </div>
            <div class="col-xs-4">
                <div class="bank-logo-box">
                    <input type="radio" title="Kotak Mahindra Bank" value="KOTAK_MAHINDRA_BANK" name="bankName"
                        formControlName="bankName" [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <label><img class="bank-logo3"
                            src="../../../assets/images/payment-collection/kotak-bank-logo.png"></label>
                </div>
            </div>
        </div>

        <div class="row box-wrapper">
            <div class="col-xs-4">
                <div class="bank-logo-box">
                    <input type="radio" title="State Bank of India" value="SBI_BANK" name="bankName"
                        formControlName="bankName" [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <label><img class="bank-logo4"
                            src="../../../assets/images/payment-collection/sbi-bank-logo.png"></label>
                </div>
            </div>

            <div class="col-xs-4">
                <div class="bank-logo-box">
                    <input type="radio" title="Canara Bank" value="CANARA_BANK" name="bankName"
                        formControlName="bankName" [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <label><img class="bank-logo1"
                            src="../../../assets/images/payment-collection/canara-bank-logo.png"></label>
                </div>

            </div>
            <div class="col-xs-4">
                <div class="bank-logo-box">
                    <input type="radio" title="ICICI Bank" value="ICICI_BANK" name="bankName" formControlName="bankName"
                        [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <label><img class="bank-logo1"
                            src="../../../assets/images/payment-collection/icici-bank-logo.png"></label>
                </div>
            </div>
        </div>

        <div class="row select-bank">
            <mat-form-field class="col-xs-12 select-bank-wrapper">
                <mat-select formControlName="bankName" placeholder="Select the bank"
                    [(ngModel)]="paymentRequest.paymentDetails.paymentIssuerCode">
                    <mat-option *ngFor="let bank of bankList" [value]="bank.value">{{bank.displayName}}
                    </mat-option>
                </mat-select>
                <mat-error class="error-message" *ngIf="netBankingControls.bankName.errors">Please select the
                    bank
                </mat-error>
            </mat-form-field>
        </div>
    </form>

</div>